import { z } from 'zod'

/**
 * Search params schema for transactions dashboard
 * This defines the structure of URL search parameters that persist filter state
 */
export const transactionsSearchSchema = z.object({
  // Search query
  query: z.string().optional(),
  
  // Filters
  dcn: z.string().optional(),
  referenceNumber: z.string().optional(),
  oriCode: z.string().optional(),
  submissionType: z.string().optional(),
  status: z.string().optional(),
  type: z.string().optional(),
  
  // Date filters
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  dateSubmitted: z.string().optional(),
  dateOfBirth: z.string().optional(),
  
  // Phone filter (search matches digits only; spaces, dashes, brackets ignored by backend)
  phoneNumber: z.string().optional(),
  
  // Pagination
  page: z.string().optional().transform((val) => val && val !== '' ? Number(val) : 1),
  
  // Chart/Statistics state - keep as string (comma-separated) to prevent JSON serialization
  // The transform will parse it, but validateSearch will convert it back to string
  selectedLocations: z.string().optional(),
  timeframe: z.enum(['daily', 'weekly', 'monthly', 'yearly']).optional(),
  selectedMetric: z.enum(['totalApplications', 'created', 'sent', 'acknowledged', 'completed', 'error']).optional(),
})

export type TransactionsSearchParams = z.infer<typeof transactionsSearchSchema>

